import React from 'react';

const DigitalMenuFooter = ({ className = '' }) => {
  return (
    <div className={`digital-menu-footer ${className}`.trim()}>
      <span className="footer-text">Powered By</span>
      <span className="footer-brand">Indolj</span>
    </div>
  );
};

export default DigitalMenuFooter;
